import React from 'react';

import { Box } from '@betterment/samba-react';

function RowLeadingContent({ children }: React.PropsWithChildren) {
  return <Box css={{ display: 'flex', gap: 'space.200' }}>{children}</Box>;
}

function RowTrailingContent({ children }: React.PropsWithChildren) {
  return <Box css={{ display: 'flex', gap: 'space.200' }}>{children}</Box>;
}

function ModalSectionRow({ children }: React.PropsWithChildren) {
  return <Box css={{ display: 'flex', justifyContent: 'space-between' }}>{children}</Box>;
}

ModalSectionRow.LeadingContent = RowLeadingContent;
ModalSectionRow.TrailingContent = RowTrailingContent;
ModalSectionRow.displayName = 'ModalSectionRow';

export { ModalSectionRow };
